// Supermove
import {gql} from '@supermove/graphql';
import {Form} from '@supermove/hooks';
import {CommentModel} from '@supermove/models';
import {withFragment} from '@supermove/utils';

export type CommentFormType = {
  commentId?: string;
  threadId: string;
  userId: string;
  body: string;
  subject: string;
};

export type FormikCommentFormType = Form<{commentForm: CommentFormType}>;

const _new = ({threadId, userId}: {threadId: string; userId: string}): CommentFormType => {
  return {
    commentId: undefined,
    threadId,
    userId,
    body: '',
    subject: '',
  };
};

const edit = withFragment<CommentModel, CommentFormType, unknown>(
  (comment) => ({
    commentId: comment.id,
    threadId: comment.threadId,
    userId: comment.userId,
    subject: comment.subject,
    body: comment.body,
  }),
  gql`
    fragment CommentForm_edit on Comment {
      id
      threadId
      userId
      body
      subject
    }
  `,
);

const toForm = ({commentId, threadId, userId, body, subject}: CommentFormType) => ({
  commentId,
  threadId,
  userId,
  body,
  subject,
});

const toMutation = ({commentId, threadId, userId, body, subject}: CommentFormType) => ({
  commentId,
  threadId,
  userId,
  body,
  subject,
});

const CommentForm = {
  toForm,
  toMutation,
  new: _new,
  edit,
};

export default CommentForm;
